import React from "react";

const AddUserToPackage = () => {
  return (
    <>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasAddUserToPackage"
        aria-labelledby="offcanvasAddUserToPackage"
        style={{ minWidth: "30%", maxWidth: "30%" }}
      >
        <div className="offcanvas-header bg-primary">
          <h4 id="offcanvasInvBillTo" className="text-white">
            Add User To Package
          </h4>
          <br></br>
          <h6>(Will upgrade if exist)</h6>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="mb-3">
              <label className="form-label">Package</label>
              <select className="form-select">
                <option>Perennial MedTech Solutions(1200.00 INR)</option>
                <option>Perennial IT</option>
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">Select Customer</label>
              <select className="form-select">
                <option>Customer 1</option>
                <option>Customer 2</option>
              </select>
            </div>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-submit">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddUserToPackage;
